import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalService } from '@siemens/ix-angular';
import { ProjectService } from 'src/app/services/project.service';
import { Project } from 'src/app/models/project.model';

@Component({
  selector: 'app-project-modals',
  templateUrl: './project-modals.component.html',
  styleUrls: ['./project-modals.component.css'],
  standalone: false
})
export class ProjectModalsComponent {
  @ViewChild('addProjectModal', { read: TemplateRef }) private addProjectModalRef!: TemplateRef<void>;
  @ViewChild('editProjectModal', { read: TemplateRef }) private editProjectModalRef!: TemplateRef<void>;
  @ViewChild('deleteProjectModal', { read: TemplateRef }) private deleteProjectModalRef!: TemplateRef<void>;

  protected readonly projectForm = this.formBuilder.group({
    name: ['', Validators.required]
  });

  constructor(
    protected readonly router: Router,
    private readonly projectService: ProjectService,
    private readonly modalService: ModalService,
    private readonly formBuilder: FormBuilder
  ) {}

  async addProject() {
    const instance = await this.modalService.open({
      content: this.addProjectModalRef,
      centered: true
    });

    instance.onDismiss.on(() => {
      this.projectForm.reset();
    });

    instance.onClose.on(() => {
      this.projectService.createProject(this.projectForm.value);
      this.projectForm.reset();
    });
  }

  async editProject(selectedProject: Project) {
    if (selectedProject) {
      this.projectForm.setValue({ name: selectedProject.name });
      const instance = await this.modalService.open({
        content: this.editProjectModalRef,
        centered: true
      });

      instance.onDismiss.on(() => {
        this.projectForm.reset();
      });

      instance.onClose.on(() => {
        this.projectService.updateProject(selectedProject.id, this.projectForm.value);
        this.projectForm.reset();
      });
    }
  }

  async openDeleteModal(project: Project) {
    const instance = await this.modalService.open({
      content: this.deleteProjectModalRef,
      data: project.name,
      centered: true
    });

    instance.onClose.on(() => {
      this.projectService.deleteProject(project.id);
    });
  }
}
